import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out, obj = user
  const [ready, setReady] = useState(false);

  const load = useCallback(async () => {
    const token = localStorage.getItem("ff_token");
    if (!token) {
      setUser(false);
      setReady(true);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("ff_token");
      setUser(false);
    } finally {
      setReady(true);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const applyAuth = (data) => {
    localStorage.setItem("ff_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => applyAuth((await api.post("/auth/login", { email, password })).data);
  const register = async (payload) => applyAuth((await api.post("/auth/register", payload)).data);
  const demoLogin = async () => applyAuth((await api.post("/auth/demo-login")).data);

  const logout = () => {
    localStorage.removeItem("ff_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, ready, login, register, demoLogin, logout, refresh: load }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
